import React, { PropsWithChildren } from 'react';

import { Background } from '../Background/Background';

import styles from './HeaderActions.module.scss';

export const HeaderActions: React.FC<PropsWithChildren> = ({ children }) => (
  <Background className={styles.headerActions}>{children}</Background>
);
